export default __webpack_public_path__ + "static/media/programmingIcon.01f7ff7f.svg";